'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _antd = require('antd');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SeparatorField = function (_React$Component) {
	_inherits(SeparatorField, _React$Component);

	function SeparatorField() {
		_classCallCheck(this, SeparatorField);

		return _possibleConstructorReturn(this, (SeparatorField.__proto__ || Object.getPrototypeOf(SeparatorField)).apply(this, arguments));
	}

	_createClass(SeparatorField, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    form = _props.form,
			    onChangeFormField = _props.onChangeFormField,
			    removeFormField = _props.removeFormField,
			    index = _props.index,
			    errorField = _props.errorField,
			    children = _props.children;
			var isFreeOnDisplayDate = form.isFreeOnDisplayDate,
			    displayDate = form.displayDate;


			return _react2.default.createElement(
				_antd.Input.Group,
				null,
				_react2.default.createElement(
					_antd.Row,
					{
						type: 'flex',
						justify: 'center',
						style: {
							marginTop: 5,
							marginBottom: 5,
							border: '1px solid #ccc',
							borderRadius: 5,
							padding: 5
						},
						gutter: [0, 15]
					},
					displayDate && _react2.default.createElement(
						_antd.Col,
						{ md: 23, sm: 23 },
						_react2.default.createElement(
							_antd.Form.Item,
							{
								validateStatus: errorField === 'isFreeOnDisplayDate' ? 'error' : 'success',
								help: errorField === 'isFreeOnDisplayDate' ? 'Valor inválido' : ''
							},
							_react2.default.createElement(
								'label',
								{ style: { marginRight: 25 } },
								'Mostrar Somente em: ',
								(0, _moment2.default)(displayDate).format('DD/MM/YYYY')
							),
							_react2.default.createElement(
								_antd.Checkbox,
								{
									checked: isFreeOnDisplayDate,
									onChange: function onChange(e) {
										return onChangeFormField('isFreeOnDisplayDate', index, e.target.checked);
									}
								},
								'Gr\xE1tis no dia da libera\xE7\xE3o'
							)
						)
					),
					_react2.default.createElement(
						_antd.Col,
						{ md: 7, sm: 23 },
						_react2.default.createElement(
							_antd.Form.Item,
							null,
							_react2.default.createElement(
								'span',
								{ style: { fontSize: 20 } },
								'Separador'
							)
						)
					),
					removeFormField !== undefined && _react2.default.createElement(
						_antd.Col,
						{ md: 1, sm: 23, style: { display: 'flex', justifyContent: 'center' } },
						_react2.default.createElement(
							_antd.Button,
							{ onClick: function onClick() {
									return removeFormField(index);
								} },
							_react2.default.createElement(_antd.Icon, { type: 'delete', style: { fontSize: 20 } })
						)
					),
					children
				)
			);
		}
	}]);

	return SeparatorField;
}(_react2.default.Component);

exports.default = SeparatorField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/genericMaterialAreas/ContentTree/formTypes/SeparatorField.js
// module id = 3233
// module chunks = 0